var Backbone = require("../../libs/backbone/backbone");
var GenericModel = require("./generic.model.ts");

var PatientsModel = GenericModel.extend(
{
    urlRoot : '/rest/api/customers/get',
    sync: function(method, model, options) {
        options = options || {};

        // Change the URL ONLY for updates
        if (method === 'update') {
            options.url = '/rest/api/customers/update/' + model.id;
        }

        // Call the default Backbone sync with your modified options
        return Backbone.sync(method, model, options);
    },
    id : null,
    firstName : "",
    lastName: "",
    phoneNumber: "",
    queueIds: []
});

module.exports = PatientsModel;